import * as React from 'react';
import styled from 'styled-components';

interface SelectLabelNodesProps {
  label?: string;
  labelId: string;
}

export function getLabelIds(testId?: string): {
  labelId: string;
} {
  const baseId = testId ?? 'select';
  const labelId = `${baseId}-label`;

  return {labelId};
}

export function SelectLabelNodes({
  label,
  labelId,
}: SelectLabelNodesProps): JSX.Element {
  return <VisuallyHidden id={labelId}>{label}</VisuallyHidden>;
}

const VisuallyHidden = styled.span`
  position: absolute;
  width: 1px;
  height: 1px;
  overflow: hidden;
  clip-path: inset(50%);
  white-space: nowrap;
`;
